(function(){
if(window.__ysoleGal)return;window.__ysoleGal=1;
var PACK=['full ritual'];
var busy=false,tmr=null;

function isPack(alt){
 var a=(alt||'').toLowerCase();
 for(var i=0;i<PACK.length;i++){if(a.indexOf(PACK[i])>=0)return true;}
 return false;
}
function packSelected(){
 var r=document.querySelector('variant-picker input[type=radio]:checked');
 if(r&&r.value)return /pack/i.test(r.value);
 var on=document.querySelector('#yof .yo.on');
 return on?/pack/i.test(on.getAttribute('data-val')):false;
}
function scroller(){return document.querySelector('media-gallery slideshow-slides');}
function shownSlides(ss){
 return [].slice.call(ss.querySelectorAll('slideshow-slide')).filter(function(s){return !s.hasAttribute('hidden');});
}
function goTo(ss,s,smooth){
 var x=s.offsetLeft-ss.offsetLeft;
 if(smooth)ss.scrollTo({left:x,behavior:'smooth'});else ss.scrollLeft=x;
}
function activeIndex(ss){
 var v=shownSlides(ss),mid=ss.scrollLeft+ss.clientWidth/2,k=0,best=1e9;
 v.forEach(function(s,i){
  var c=s.offsetLeft-ss.offsetLeft+s.offsetWidth/2,d=Math.abs(c-mid);
  if(d<best){best=d;k=i;}
 });
 return k;
}
function paint(ss){
 var d=document.querySelector('.ydots');if(!d)return;
 var k=activeIndex(ss);
 [].forEach.call(d.children,function(b,i){b.classList.toggle('on',i===k);});
}
function dots(ss){
 var host=document.querySelector('media-gallery');if(!host)return;
 var old=host.querySelector('.ydots');if(old)old.remove();
 var v=shownSlides(ss);if(v.length<2)return;
 var d=document.createElement('div');d.className='ydots';
 v.forEach(function(s,i){
  var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Image '+(i+1));
  if(i===0)b.className='on';
  b.addEventListener('click',function(){goTo(ss,s,true);});
  d.appendChild(b);
 });
 host.appendChild(d);
 if(!ss.dataset.ybound){
  ss.dataset.ybound='1';
  var t;ss.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){paint(ss);},70);},{passive:true});
 }
}
function filter(){
 var ss=scroller();if(!ss)return;
 var want=packSelected();
 [].slice.call(ss.querySelectorAll('slideshow-slide')).forEach(function(s){
  var im=s.querySelector('img');
  var show=isPack(im?im.alt:'')===want;
  if(show)s.removeAttribute('hidden');else s.setAttribute('hidden','');
 });
 var v=shownSlides(ss);
 if(v.length)goTo(ss,v[0],false);
 dots(ss);
}
function needsFix(){
 var ss=scroller();if(!ss)return false;
 var want=packSelected(),bad=false;
 [].slice.call(ss.querySelectorAll('slideshow-slide')).forEach(function(s){
  var im=s.querySelector('img');
  if((isPack(im?im.alt:'')===want)===s.hasAttribute('hidden'))bad=true;
 });
 if(!document.querySelector('media-gallery .ydots'))bad=true;
 return bad;
}
function run(){busy=true;filter();setTimeout(function(){busy=false;},60);}
function schedule(){if(busy)return;clearTimeout(tmr);tmr=setTimeout(function(){if(needsFix())run();},80);}

document.addEventListener('click',function(e){
 var arrow=e.target.closest?e.target.closest('media-gallery .slideshow-control'):null;
 if(!arrow)return;
 var ss=scroller();if(!ss)return;
 e.preventDefault();e.stopPropagation();
 var v=shownSlides(ss);if(!v.length)return;
 var k=activeIndex(ss)+(arrow.classList.contains('slideshow-control--next')?1:-1);
 if(k<0)k=v.length-1;if(k>=v.length)k=0;
 goTo(ss,v[k],true);
},true);

document.addEventListener('click',function(e){
 var c=e.target.closest?e.target.closest('#yof .yo'):null;
 if(!c)return;
 var r=[].slice.call(document.querySelectorAll('variant-picker input[type=radio]'));
 var t=r.filter(function(i){return i.value===c.getAttribute('data-val');})[0];
 if(!t)return;
 e.preventDefault();t.click();
 [].forEach.call(document.querySelectorAll('#yof .yo'),function(x){x.classList.toggle('on',x===c);});
 [60,320,700].forEach(function(ms){setTimeout(run,ms);});
},true);

new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
setTimeout(run,400);
})();